import { createFileRoute } from '@tanstack/react-router'

import SubscriptionUsage from '~/boundedContext/settings/pages/subscription-usage'

export const Route = createFileRoute('/_main-layout/settings/subscription/usage')({
  component: SubscriptionUsage,
})
